// color palette could use: #317E70, #DFB750, #7B2337, #DD6B47, #0D6072

const escapeGames = [
  "大盜樂比特",
  "轟!烘!哄!",
  "境壽司",
  "逃出閻王殿",
  "難道只是拯救童話世界而已嘛?",
  "咒雨",
  "怨憶",
  "辦公室有詭",
  "幻隱光靈：學院",
  "詭盜影",
  "逃兵",
  "庫克王國2-復仇的餓火",
  "玄武石醫院",
  "MY後台苦路",
  "鬱金香",
  "詭廁",
  "師密處",
  "魔法學徒", 
  "平安戲院",
  "蒙利亞修道院",
  "友戲",
  "鬼仙",
  "富得誰負",
  "誰是長安串串王?",
  "遺怨",
  "幻隱光靈：屍禁",
  "牛頭村",
  "奪魂獄：滑進焚化爐",
  "民雄門市",
  "失物招領",
  "機蜜任務：BEE!",
  "猛鬼大廈",
  "掘2.0",
  "不存在的女兒",
  "罪夢真相",
  "山梔照相館",
  "法老之墓",
  "零堂",
  "守靈人",
  "獄到鬼",
  "重返糖果屋",
  "心魔",
]

const outdoorGames = [
  "海市神樓", 
  "穿越時空的航海家", 
  "彼時之光", 
  "HELLO KITTY 幾米解謎", 
  "仙靈傳奇：闇石再起", 
  "捉咪藏", 
  "加鴨", 
  "貓咪追逐戰", 
  "富饒之埕", 
  "一個人的捉迷藏", 
  "自由錄", 
  "逃脫！100萬美元的機關屋（含重啟版）", 
  "女巫的使者", 
  "星際探險隊"
];

const theaterGames = [
  "卦",
  "理性自由法則",
  "獄門神社",
  "INSANE"
];

const proxyGames = [
  "詭廁", 
  "魔法學徒", 
  "怪奇雜貨舖", 
  "牛頭村", 
  "INSANE", 
  "逃脫！100萬美元的機關屋（含重啟版）", 
  "守靈人"
];

const horrorGames = [
  "咒雨",
  "怨憶",
  "辦公室有詭",
  "詭盜影",
  "逃兵",
  "玄武石醫院",
  "鬱金香",
  "詭廁",
  "平安戲院",
  "蒙利亞修道院",
  "友戲",
  "鬼仙",
  "遺怨",
  "幻隱光靈：屍禁",
  "牛頭村",
  "奪魂獄：滑進焚化爐",
  "民雄門市",
  "失物招領",
  "猛鬼大廈",
  "不存在的女兒",
  "罪夢真相",
  "零堂",
  "守靈人",
  "心魔",
  "卦",
  "獄門神社",
  "INSANE"
]

const essentialGames = [
  "大盜樂比特",
  "轟!烘!哄!",
  "境壽司",
  "逃出閻王殿",
  "難道只是拯救童話世界而已嘛?",
  "咒雨",
  "怨憶",
  "辦公室有詭",
  "幻隱光靈：學院",
  "詭盜影",
  "逃兵",
  "庫克王國2-復仇的餓火",
  "玄武石醫院",
  "詭廁",
  "師密處",
  "魔法學徒", 
  "蒙利亞修道院",
  "友戲",
  "鬼仙",
  "富得誰負",
  "遺怨",
  "幻隱光靈：屍禁",
  "奪魂獄：滑進焚化爐",
  "民雄門市",
  "失物招領",
  "機蜜任務：BEE!",
  "猛鬼大廈",
  "不存在的女兒",
  "罪夢真相",
  "山梔照相館",
  "法老之墓",
  "零堂",
  "守靈人",
  "獄到鬼",
  "重返糖果屋",
  "心魔",
]

const generalGames = [...new Set([...escapeGames, ...outdoorGames, ...theaterGames, ...proxyGames])];
const generalGamesExcludeOutdoor = generalGames.filter(game => !outdoorGames.includes(game));


// 提名候選名單為本站有上架的遊戲，評價數量過少的不列入候選名單，但您可以自行輸入不在此列但您認為應該入選的遊戲。
export const firstRoundCandidates = {
  scenes: {
    name: "【年度最佳場景遊戲】",
    description: "此遊戲中的造景及道具栩栩如生，讓人以視覺觸覺感官身歷其境。精心打造的場景設計不僅具備高度還原性，更能透過細膩的材質與燈光營造，讓玩家完全沉浸在遊戲世界中。",
    candidates: generalGamesExcludeOutdoor,
    limit: 3,
  },
  mechanism: {
    name: "【年度最佳機關遊戲】",
    description: "此遊戲中使用的機關品質與數量兼具，呈現方式具備巧思，讓人有耳目一新的感覺。機關設計邏輯清晰且富有創意，操作手感流暢，每個機關都與主題完美融合，展現製作團隊的技術實力。",
    candidates: generalGamesExcludeOutdoor,
    limit: 3,
  },
  story: {
    name: "【年度最佳劇情遊戲】",
    description: "此遊戲的劇情完整，且遊戲推進節奏得宜，在遊戲結束後仍然能夠讓玩家有餘韻繞樑的感受。故事架構層次分明，角色塑造立體生動，情節轉折自然流暢，讓玩家深度投入其中。",
    candidates: generalGames,
    limit: 3,
  },
  puzzle: {
    name: "【年度最佳謎題遊戲】",
    description: "此遊戲中出現的謎題具備深度與巧思，並切合該遊戲主題，不會有格格不入的感覺。謎題設計層次豐富，從易到難循序漸進，解謎過程充滿樂趣，讓玩家在思考中獲得成就感。",
    candidates: generalGames,
    limit: 3,
  },
  atmosphere: {
    name: "【年度最佳氣氛遊戲】",
    description: "此遊戲利用演員或是NPC、聲音、燈光、水流煙霧等特效提升氣氛且不突兀。透過精心設計的環境氛圍，成功營造出與主題相符的情境感受，讓玩家完全融入遊戲世界的獨特魅力中。（排除恐怖主題）",
    candidates: generalGames.filter(game => !horrorGames.includes(game)),
    limit: 3,
  },
  horror: {
    name: "【年度最佳恐怖氣氛遊戲】",
    description: "此遊戲利用演員或是NPC、聲音、燈光、水流煙霧等特效提升恐怖氣氛。恐怖元素運用得當，營造出層層遞進的緊張感，讓玩家在驚嚇與刺激中體驗極致的腎上腺素飆升。",
    candidates: horrorGames,
    limit: 3,
  },
  creative: {
    name: "【年度最佳創新遊戲】",
    description: "此遊戲的呈現或者進行方式非常創新，在此之前相當少見，並且提升了遊戲可玩性與豐富度。突破傳統框架，引入前所未見的遊戲機制或互動方式，為密室逃脫產業帶來全新的可能性。",
    candidates: generalGames,
    limit: 3,
  },
  essential: {
    name: "【年度最佳精粹密室】",
    description: "此遊戲秉持本格密室的規格，讓玩家在有限的時間與空間體驗到精心設計的密室逃脫基本元素，讓玩家體驗到密室逃脫最純粹且物超所值的遊戲體驗。（入圍資格：遊戲時長 90 分鐘內且單價 800 元內）",
    candidates: essentialGames,
    limit: 3,
  },
  outdoor: {
    name: "【年度最佳實境解謎】",
    description: "此遊戲讓玩家在實際場域中探索，透過觀察景物來解開謎題，讓玩家能夠在富饒趣味的遊戲過程中對地方的歷史地理或是社會議題有更深刻的了解。",
    candidates: outdoorGames,
    limit: 3,
  },
  theater: {
    name: "【年度最佳沉浸式劇場】",
    description: "透過精湛的表演技巧與巧妙的互動設計，玩家能夠深度參與劇情發展，在角色扮演中體驗到前所未有的代入感，感受劇場藝術與遊戲的完美融合。",
    candidates: theaterGames,
    limit: 2,
  },
  proxy: {
    name: "【年度最佳代理遊戲】",
    description: "此遊戲自國外引進，代理商不僅忠實呈現原作精神，更針對在地文化與消費習慣進行細膩的改良，讓國外的創意設計能夠適當融入本土市場，為玩家帶來兼具國際水準與在地特色的優質體驗。",
    candidates: proxyGames,
    limit: 2,
  },
}

const popularityCandidates2024 = [
  {
      "id": "20644",
      "title": "大盜樂比特",
      "firmName": "迷失地工作室"
  },
  {
      "id": "20556",
      "title": "魔女魅影",
      "firmName": "FK工作室"
  },
  {
      "id": "20887",
      "title": "海市神樓",
      "firmName": "聚樂邦 Clubon"
  },
  {
      "id": "20500",
      "title": "幻隱光靈：仙蹤",
      "firmName": "西瓜皮育樂"
  },
  {
      "id": "20511",
      "title": "幻隱光靈：禁地",
      "firmName": "西瓜皮育樂"
  },
  {
      "id": "20559",
      "title": "轟！烘！哄！",
      "firmName": "夢罟密室逃脫"
  },
  {
      "id": "20906",
      "title": "境壽司",
      "firmName": "根號三工作室_密室逃脫會所"
  },
  {
      "id": "21046",
      "title": "穿越時空的航海家",
      "firmName": "聚樂邦 Clubon"
  },
  {
      "id": "21096",
      "title": "皮克蒙之書",
      "firmName": "智慧獵人"
  },
  {
      "id": "20920",
      "title": "逃出閻王殿",
      "firmName": "說故事工作室"
  },
  {
      "id": "21009",
      "title": "逃離監獄島",
      "firmName": "LOST Taiwan 迷の密失"
  },
  {
      "id": "21135",
      "title": "難道只是拯救童話世界而已嘛？",
      "firmName": "謎鹿實境遊戲工作室"
  },
  {
      "id": "21526",
      "title": "彼時之光",
      "firmName": "聚樂邦 Clubon"
  },
  {
      "id": "21495",
      "title": "咒雨",
      "firmName": "夢遊王國"
  },
  {
      "id": "22502",
      "title": "重生以前",
      "firmName": "城市新頌聖教會"
  },
  {
      "id": "21881",
      "title": "蓬萊仙島",
      "firmName": "逃脫吧官方帳號"
  },
  {
      "id": "21664",
      "title": "怨憶",
      "firmName": "闇間工作室"
  },
  {
      "id": "21785",
      "title": "古德帕帕",
      "firmName": "夢罟密室逃脫"
  },
  {
      "id": "21799",
      "title": "三木爺爺的秘密甜點",
      "firmName": "夢罟密室逃脫"
  },
  {
      "id": "21801",
      "title": "告別式",
      "firmName": "夢罟密室逃脫"
  },
  {
      "id": "21642",
      "title": "卦",
      "firmName": "開溜製造所"
  },
  {
      "id": "21797",
      "title": "冠軍球衣",
      "firmName": "夢罟密室逃脫"
  },
  {
      "id": "21936",
      "title": "辦公室有詭",
      "firmName": "SWOT 微機解秘"
  },
  {
      "id": "21718",
      "title": "幻隱光靈：學院",
      "firmName": "西瓜皮育樂"
  },
  {
      "id": "21985",
      "title": "HELLO KITTY 幾米解謎",
      "firmName": "居加謎解"
  },
  {
      "id": "22012",
      "title": "詭盜影",
      "firmName": "少一根筋實境遊戲工作室"
  },
  {
      "id": "22001",
      "title": "逃兵",
      "firmName": "灰象逃脫工作室"
  },
  {
      "id": "21973",
      "title": "庫克王國2-復仇的餓火",
      "firmName": "玩有引力創意工作室"
  },
  {
      "id": "22403",
      "title": "解密！健康調查團",
      "firmName": "留聲貓遊戲工作室"
  },
  {
      "id": "22072",
      "title": "玄武石醫院",
      "firmName": "1798真人實境遊戲"
  },
  {
      "id": "22845",
      "title": "五間厝Sugar",
      "firmName": "雲林記憶Cool"
  },
  {
      "id": "22095",
      "title": "MY後台苦路｜MY Backstage Crew",
      "firmName": "劇戲密疑工作室"
  },
  {
      "id": "23205",
      "title": "仙靈傳奇：闇石再起",
      "firmName": "玩轉城市"
  },
  {
      "id": "22031",
      "title": "獵人實境解謎遊戲-貪婪之島篇",
      "firmName": "西瓜皮育樂"
  },
  {
      "id": "23021",
      "title": "捉咪藏",
      "firmName": "Miss GAME"
  },
  {
      "id": "23023",
      "title": "加鴨",
      "firmName": "Miss GAME"
  },
  {
      "id": "23533",
      "title": "理性自由法則",
      "firmName": "立繹法則沉浸式劇場"
  },
  {
      "id": "22220",
      "title": "康斯特學園：惡獸起源",
      "firmName": "謀殺衛斯理工作室"
  },
  {
      "id": "22335",
      "title": "鬱金香",
      "firmName": "A5 Studio-全員脫逃中"
  },
  {
      "id": "22489",
      "title": "貓咪追逐戰",
      "firmName": "薛丁貓實驗室"
  },
  {
      "id": "22531",
      "title": "詭廁",
      "firmName": "勃根地桌遊休閒館"
  },
  {
      "id": "22573",
      "title": "師密處",
      "firmName": "頭癮創意遊戲"
  },
  {
      "id": "22552",
      "title": "魔法學徒",
      "firmName": "BGLOCK推理解謎館"
  },
  {
      "id": "22557",
      "title": "怪奇雜貨舖",
      "firmName": "BGLOCK推理解謎館"
  },
  {
      "id": "22637",
      "title": "諜影：申城風暴",
      "firmName": "大顆壽司｜Dark Souls"
  },
  {
      "id": "22448",
      "title": "平安戲院",
      "firmName": "笨蛋工作室密室逃脫"
  },
  {
      "id": "22699",
      "title": "謎島伏流",
      "firmName": "拉普星球 Larp Planet"
  },
  {
      "id": "22728",
      "title": "蒙利亞修道院",
      "firmName": "爆謎花密室逃脫工作室"
  },
  {
      "id": "22753",
      "title": "富饒之埕",
      "firmName": "城市尋寶｜城市謎案"
  },
  {
      "id": "22792",
      "title": "友戲",
      "firmName": "謎宇宙Myverse"
  },
  {
      "id": "22672",
      "title": "鬼仙",
      "firmName": "神話密室脫逃工坊"
  },
  {
      "id": "22925",
      "title": "富得誰負",
      "firmName": "Througher 穿越者"
  },
  {
      "id": "23018",
      "title": "誰是長安串串王",
      "firmName": "霖麟娛樂時光研究室"
  },
  {
      "id": "22987",
      "title": "遺怨",
      "firmName": "癮密In-me密室逃脫工作室"
  },
  {
      "id": "23407",
      "title": "自由錄",
      "firmName": "鯤寶創意有限公司"
  },
  {
      "id": "22877",
      "title": "幻隱光靈：屍禁",
      "firmName": "西瓜皮育樂"
  },
  {
      "id": "22958",
      "title": "牛頭村",
      "firmName": "謎書狗工作室"
  },
  {
      "id": "23073",
      "title": "獄門神社",
      "firmName": "Escer異世客密室逃脫工作室"
  },
  {
      "id": "22934",
      "title": "奪魂獄：滑進焚化爐",
      "firmName": "Mystoto Escape Games 密室逃脫"
  },
  {
      "id": "22913",
      "title": "民雄門市",
      "firmName": "說故事工作室"
  },
  {
      "id": "23101",
      "title": "失物招領",
      "firmName": "謎失工作室"
  },
  {
      "id": "23000",
      "title": "機蜜任務：BEE！",
      "firmName": "瘋密工作室"
  },
  {
      "id": "22944",
      "title": "INSANE",
      "firmName": "夢遊王國"
  },
  {
      "id": "23198",
      "title": "猛鬼大廈",
      "firmName": "LOST Taiwan 迷の密失"
  },
  {
      "id": "23170",
      "title": "逃脫！100萬美元的機關屋",
      "firmName": "頂級豬排遊戲工作室"
  },
  {
      "id": "23185",
      "title": "掘 2.0",
      "firmName": "玩笑實驗室 Plab."
  },
  {
      "id": "23163",
      "title": "不存在的女兒",
      "firmName": "草咩咩遊戲工作室"
  },
  {
      "id": "23295",
      "title": "女巫的使者",
      "firmName": "聚樂邦 Clubon"
  },
  {
      "id": "23268",
      "title": "罪夢真相",
      "firmName": "Througher 穿越者"
  },
  {
      "id": "23321",
      "title": "山梔照相館",
      "firmName": "格林跳-真實密室遊戲"
  },
  {
      "id": "23638",
      "title": "法老之墓",
      "firmName": "逃生門工作室"
  },
  {
      "id": "23379",
      "title": "零堂",
      "firmName": "SWOT 微機解秘"
  },
  {
      "id": "23388",
      "title": "守靈人",
      "firmName": "BGLOCK推理解謎館"
  },
  {
      "id": "23479",
      "title": "星際探險隊",
      "firmName": "Team Unlock Plus"
  },
  {
      "id": "23639",
      "title": "獄到鬼",
      "firmName": "逃生門工作室"
  },
  {
      "id": "23503",
      "title": "重返糖果屋",
      "firmName": "神不在場實境遊戲"
  },
  {
      "id": "23524",
      "title": "心魔",
      "firmName": "玩出計劃創意工作室"
  }
]

const rookieCandidates2024 = [
  {
    id: "21638",
    title: "開溜製造所",
    logoUrl: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-LOGO.jpeg?fit=400%2C400&ssl=1"
  },
  {
    id: "21922",
    title: "SWOT 微機解秘",
    logoUrl: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/04/-LOGO-e1713632084880.jpeg?fit=400%2C400&ssl=1"
  },
  {
    id: "22716",
    title: "爆謎花密室逃脫工作室",
    logoUrl: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/09/-logo-e1726326991186.jpg?fit=400%2C400&ssl=1"
  },
  {
    id: "22974",
    title: "癮密In-me密室逃脫工作室",
    logoUrl: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/10/-LOGO-e1729560011334.jpg?fit=400%2C400&ssl=1"
  },
  {
    id: "23397",
    title: "鯤寶創意有限公司",
    logoUrl: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/12/%E9%AF%A4%E5%AF%B6%E5%85%B1%E4%BA%AB%E6%96%87%E6%97%85-LOGO.jpg?fit=1080%2C1080&ssl=1"
  },
  {
    id: "23473",
    title: "Team Unlock Plus",
    logoUrl: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/12/TeamUnlockPlus-logo.jpg?fit=400%2C400&ssl=1"
  },
]

export const secondRoundCandidates = {
  scenes: {
    name: firstRoundCandidates.scenes.name,
    description: firstRoundCandidates.scenes.description,
    limit: 1,
    candidates: [
      {
        id: "21495",
        title: "咒雨",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E5%92%92%E9%9B%A8%E5%AE%98%E7%B6%B2_05-%E9%80%83%E8%84%AB%E5%90%A7-2500x1300-1.jpg?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "21642",
        title: "卦",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-%E5%8D%A6-02.png?fit=720%2C378&ssl=1",
        firmName: "開溜製造所",
      },
      {
        id: "22448",
        title: "平安戲院",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/08/%E7%AC%A8%E8%9B%8B%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E5%B9%B3%E5%AE%89%E6%88%B2%E9%99%A2-02.jpg?fit=720%2C378&ssl=1",
        firmName: "笨蛋工作室密室逃脫",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },
      {
        id: "22944",
        title: "INSANE",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/-INSANE-01-e1729533560362.png?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
    ]
  },
  mechanism: {
    name: firstRoundCandidates.mechanism.name,
    description: firstRoundCandidates.mechanism.description,
    limit: 1,
    candidates: [
      {
        id: "21495",
        title: "咒雨",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E5%92%92%E9%9B%A8%E5%AE%98%E7%B6%B2_05-%E9%80%83%E8%84%AB%E5%90%A7-2500x1300-1.jpg?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "22448",
        title: "平安戲院",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/08/%E7%AC%A8%E8%9B%8B%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E5%B9%B3%E5%AE%89%E6%88%B2%E9%99%A2-02.jpg?fit=720%2C378&ssl=1",
        firmName: "笨蛋工作室密室逃脫",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },
      {
        id: "22913",
        title: "民雄門市",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E8%AA%AA%E6%95%85%E4%BA%8B-%E6%B0%91%E9%9B%84%E9%96%80%E5%B8%82-01.jpg?fit=720%2C378&ssl=1",
        firmName: "說故事工作室",
      },
      {
        id: "23000",
        title: "機蜜任務：BEE！",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%98%8B%E5%AF%86%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E6%A9%9F%E8%9C%9C%E4%BB%BB%E5%8B%99-04-1.png?fit=720%2C378&ssl=1",
        firmName: "瘋密工作室",
      },
    ]
  },
  story: {
    name: firstRoundCandidates.story.name,
    description: firstRoundCandidates.story.description,
    limit: 1,
    candidates: [
      {
        id: "21495",
        title: "咒雨",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E5%92%92%E9%9B%A8%E5%AE%98%E7%B6%B2_05-%E9%80%83%E8%84%AB%E5%90%A7-2500x1300-1.jpg?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "21642",
        title: "卦",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-%E5%8D%A6-02.png?fit=720%2C378&ssl=1",
        firmName: "開溜製造所",
      },
      {
        id: "22335",
        title: "鬱金香",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/07/deba192e-4912-44e5-8965-801ede0eec89-1440x960-1-e1720676940717.jpg?fit=720%2C378&ssl=1",
        firmName: "A5 Studio",
      },
      {
        id: "22448",
        title: "平安戲院",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/08/%E7%AC%A8%E8%9B%8B%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E5%B9%B3%E5%AE%89%E6%88%B2%E9%99%A2-02.jpg?fit=720%2C378&ssl=1",
        firmName: "笨蛋工作室密室逃脫",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },
      {
        id: "23163",
        title: "不存在的女兒",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/11/%E8%8D%89%E5%92%A9%E5%92%A9-%E4%B8%8D%E5%AD%98%E5%9C%A8%E7%9A%84%E5%A5%B3%E5%85%92-01.jpg?fit=720%2C378&ssl=1",
        firmName: "草咩咩遊戲工作室",
      },
    ]
  },
  puzzle: {
    name: firstRoundCandidates.puzzle.name,
    description: firstRoundCandidates.puzzle.description,
    limit: 1,
    candidates: [
      {
        id: "20644",
        title: "大盜樂比特",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/01/%E8%BF%B7%E5%A4%B1%E5%9C%B0-%E5%A4%A7%E7%9B%9C%E6%A8%82%E6%AF%94%E7%89%B9-01.png?fit=720%2C378&ssl=1",
        firmName: "迷失地工作室",
      },
      {
        id: "21495",
        title: "咒雨",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E5%92%92%E9%9B%A8%E5%AE%98%E7%B6%B2_05-%E9%80%83%E8%84%AB%E5%90%A7-2500x1300-1.jpg?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "22001",
        title: "逃兵",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/05/-%E9%80%83%E5%85%B5-02-e1715266364637.jpg?fit=720%2C378&ssl=1",
        firmName: "灰象逃脫工作室",
      },
      {
        id: "21973",
        title: "庫克王國2-復仇的餓火",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/05/%E7%8E%A9%E6%9C%89%E5%BC%95%E5%8A%9B-%E5%BA%AB%E5%85%8B%E7%8E%8B%E5%9C%8B2.jpeg?fit=720%2C378&ssl=1",
        firmName: "玩有引力創意工作室",
      },
      {
        id: "23170",
        title: "逃脫！100萬美元的機關屋",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/11/Scrap-Conan2024-01.jpg?fit=720%2C378&ssl=1",
        firmName: "頂級豬排遊戲工作室",
      },
    ]
  },
  atmosphere: {
    name: firstRoundCandidates.atmosphere.name,
    description: firstRoundCandidates.atmosphere.description,
    limit: 1,
    candidates: [
      {
        id: "20920",
        title: "逃出閻王殿",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/01/%E8%AA%AA%E6%95%85%E4%BA%8B%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E9%80%83%E5%87%BA%E9%96%BB%E7%8E%8B%E6%AE%BF-01.jpeg?fit=720%2C378&ssl=1",
        firmName: "說故事工作室",
      },
      {
        id: "22095",
        title: "MY後台苦路｜MY Backstage Crew",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/06/%E5%8A%87%E6%88%B2%E5%AF%86%E7%96%91-MY%E5%BE%8C%E5%8F%B0%E8%8B%A6%E8%B7%AF-02.jpg?fit=720%2C378&ssl=1",
        firmName: "劇戲密疑工作室",
      },
      {
        id: "21973",
        title: "庫克王國2-復仇的餓火",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/05/%E7%8E%A9%E6%9C%89%E5%BC%95%E5%8A%9B-%E5%BA%AB%E5%85%8B%E7%8E%8B%E5%9C%8B2.jpeg?fit=720%2C378&ssl=1",
        firmName: "玩有引力創意工作室",
      },
      {
        id: "22557",
        title: "怪奇雜貨舖",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/08/BGLOCK-%E6%80%AA%E5%A5%87%E9%9B%9C%E8%B2%A8%E9%8B%AA-02.png?fit=720%2C378&ssl=1",
        firmName: "BGLOCK推理解謎館",
      },
      {
        id: "23000",
        title: "機蜜任務：BEE！",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%98%8B%E5%AF%86%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E6%A9%9F%E8%9C%9C%E4%BB%BB%E5%8B%99-04-1.png?fit=720%2C378&ssl=1",
        firmName: "瘋密工作室",
      },
    ]
  },
  horror: {
    name: firstRoundCandidates.horror.name,
    description: firstRoundCandidates.horror.description,
    limit: 1,
    candidates: [
      {
        id: "21642",
        title: "卦",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-%E5%8D%A6-02.png?fit=720%2C378&ssl=1",
        firmName: "開溜製造所",
      },
      {
        id: "22531",
        title: "詭廁",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/08/BGL-%E8%A9%AD%E5%BB%81-02.jpg?fit=720%2C378&ssl=1",
        firmName: "勃根地桌遊休閒館",
      },
      {
        id: "22958",
        title: "牛頭村",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/10/-%E7%89%9B%E9%A0%AD%E6%9D%91-01-e1729741035683.jpg?fit=720%2C378&ssl=1",
        firmName: "謎書狗工作室",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },

      {
        id: "22944",
        title: "INSANE",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/-INSANE-01-e1729533560362.png?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
    ]
  },
  creative: {
    name: firstRoundCandidates.creative.name,
    description: firstRoundCandidates.creative.description,
    limit: 1,
    candidates: [
      {
        id: "21642",
        title: "卦",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-%E5%8D%A6-02.png?fit=720%2C378&ssl=1",
        firmName: "開溜製造所",
      },
      {
        id: "22095",
        title: "MY後台苦路｜MY Backstage Crew",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/06/%E5%8A%87%E6%88%B2%E5%AF%86%E7%96%91-MY%E5%BE%8C%E5%8F%B0%E8%8B%A6%E8%B7%AF-02.jpg?fit=720%2C378&ssl=1",
        firmName: "劇戲密疑工作室",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },
      {
        id: "22944",
        title: "INSANE",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/-INSANE-01-e1729533560362.png?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "23000",
        title: "機蜜任務：BEE！",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%98%8B%E5%AF%86%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E6%A9%9F%E8%9C%9C%E4%BB%BB%E5%8B%99-04-1.png?fit=720%2C378&ssl=1",
        firmName: "瘋密工作室",
      },
    ]
  },
  essential: {
    name: firstRoundCandidates.essential.name,
    description: firstRoundCandidates.essential.description,
    limit: 1,
    candidates: [
      {
        id: "20644",
        title: "大盜樂比特",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/01/%E8%BF%B7%E5%A4%B1%E5%9C%B0-%E5%A4%A7%E7%9B%9C%E6%A8%82%E6%AF%94%E7%89%B9-01.png?fit=720%2C378&ssl=1",
        firmName: "迷失地工作室",
      },
      {
        id: "21495",
        title: "咒雨",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E5%92%92%E9%9B%A8%E5%AE%98%E7%B6%B2_05-%E9%80%83%E8%84%AB%E5%90%A7-2500x1300-1.jpg?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "21973",
        title: "庫克王國2-復仇的餓火",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/05/%E7%8E%A9%E6%9C%89%E5%BC%95%E5%8A%9B-%E5%BA%AB%E5%85%8B%E7%8E%8B%E5%9C%8B2.jpeg?fit=720%2C378&ssl=1",
        firmName: "玩有引力創意工作室",
      },
      {
        id: "22728",
        title: "蒙利亞修道院",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/09/%E7%88%86%E8%AC%8E%E8%8A%B1-%E8%92%99%E5%88%A9%E4%BA%9E%E4%BF%AE%E9%81%93%E9%99%A2-01.jpg?fit=720%2C378&ssl=1",
        firmName: "爆謎花密室逃脫工作室",
      },
      {
        id: "23000",
        title: "機蜜任務：BEE！",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%98%8B%E5%AF%86%E5%B7%A5%E4%BD%9C%E5%AE%A4-%E6%A9%9F%E8%9C%9C%E4%BB%BB%E5%8B%99-04-1.png?fit=720%2C378&ssl=1",
        firmName: "瘋密工作室",
      },
    ]
  },
  outdoor: {
    name: firstRoundCandidates.outdoor.name,
    description: firstRoundCandidates.outdoor.description,
    limit: 1,
    candidates: [
      {
        id: "20887",
        title: "海市神樓",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/01/2160x.webp?fit=720%2C378&ssl=1",
        firmName: "聚樂邦 Clubon",
      },
      {
        id: "21985",
        title: "HELLO KITTY 幾米解謎",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/05/%E9%80%83%E8%84%AB%E5%90%A7%E5%B0%81%E9%9D%A2.png?fit=1200%2C631&ssl=1",
        firmName: "居加謎解",
      },
      {
        id: "22753",
        title: "富饒之埕",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/09/%E5%AF%8C%E9%A5%92%E4%B9%8B%E5%9F%95.jpg?fit=720%2C378&ssl=1",
        firmName: "城市尋寶｜城市謎案",
      },
      {
        id: "23170",
        title: "逃脫！100萬美元的機關屋",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/11/Scrap-Conan2024-01.jpg?fit=720%2C378&ssl=1",
        firmName: "頂級豬排遊戲工作室",
      },
      {
        id: "23295",
        title: "女巫的使者",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/11/-%E5%A5%B3%E5%B7%AB%E7%9A%84%E4%BD%BF%E8%80%85-01-e1732678392345.png?fit=720%2C378&ssl=1",
        firmName: "聚樂邦 Clubon",
      },
    ],
  },
  theater: {
    name: firstRoundCandidates.theater.name,
    description: firstRoundCandidates.theater.description,
    limit: 1,
    candidates: [
      {
        id: "21642",
        title: "卦",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/03/%E9%96%8B%E6%BA%9C%E8%A3%BD%E9%80%A0%E6%89%80-%E5%8D%A6-02.png?fit=720%2C378&ssl=1",
        firmName: "開溜製造所",
      },
      {
        id: "23073",
        title: "獄門神社",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/10/%E7%95%B0%E4%B8%96%E5%AE%A2-%E7%8D%84%E9%96%80%E7%A5%9E%E7%A4%BE-02.jpg?fit=720%2C378&ssl=1",
        firmName: "Escer異世客密室逃脫工作室",
      },
      {
        id: "22944",
        title: "INSANE",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/-INSANE-01-e1729533560362.png?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
    ]
  },
  proxy: {
    name: firstRoundCandidates.proxy.name,
    description: firstRoundCandidates.proxy.description,
    limit: 1,
    candidates: [
      {
        id: "22531",
        title: "詭廁",
        gameBannerSrc: "https://i0.wp.com/content.escape.bar/wp-content/uploads/2024/08/BGL-%E8%A9%AD%E5%BB%81-02.jpg?fit=720%2C378&ssl=1",
        firmName: "勃根地桌遊休閒館",
      },
      {
        id: "22557",
        title: "怪奇雜貨舖",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/08/BGLOCK-%E6%80%AA%E5%A5%87%E9%9B%9C%E8%B2%A8%E9%8B%AA-02.png?fit=720%2C378&ssl=1",
        firmName: "BGLOCK推理解謎館",
      },
      {
        id: "22958",
        title: "牛頭村",
        gameBannerSrc: "https://i1.wp.com/content.escape.bar/wp-content/uploads/2024/10/-%E7%89%9B%E9%A0%AD%E6%9D%91-01-e1729741035683.jpg?fit=720%2C378&ssl=1",
        firmName: "謎書狗工作室",
      },
      {
        id: "22944",
        title: "INSANE",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/10/-INSANE-01-e1729533560362.png?fit=720%2C378&ssl=1",
        firmName: "夢遊王國",
      },
      {
        id: "23170",
        title: "逃脫！100萬美元的機關屋",
        gameBannerSrc: "https://i2.wp.com/content.escape.bar/wp-content/uploads/2024/11/Scrap-Conan2024-01.jpg?fit=720%2C378&ssl=1",
        firmName: "頂級豬排遊戲工作室",
      },
    ]
  },
  popularity: {
    name: "【年度最佳人氣遊戲】",
    description: "不論此遊戲的各面向如何，整體遊玩體驗非常愉快，雖然可能在某些技術層面並非最頂尖，但整體設計均衡，遊戲過程充滿歡樂，讓玩家留下深刻的美好回憶，透過這一票給予肯定。",
    limit: 3,
    candidates: popularityCandidates2024
  },
  rookies: {
    name: "【年度最佳新秀工作室】",
    description: "不論是設計或者服務都非常值得給予高度期待的新工作室。雖然成立時間不長，但已展現出優秀的創作潛力與專業態度，在遊戲品質與服務水準上都有亮眼表現，值得持續關注。",
    limit: 2,
    candidates: rookieCandidates2024
  }
}